import React, { useEffect, useState } from "react";
import { responseMsg } from "../../common/ResponseMsg";
import { useForm, Controller } from "react-hook-form";
import Flex from "../../../shared/components/Flex";
import ModalButton from "../../../shared/components/ModalButton";
import useDevice from "../../../shared/hooks/useDevice";
import Grid from "../../../shared/components/Grid";
import LabelInput from "../../../shared/components/LabelInput";
import CommonSelect from "../../../shared/components/CommonSelect";
import Spacer from "../../../shared/components/Spacer";
import { useAlert } from "../../../shared/components/AlertProvider";

function UserAddModal({ rendering }) {
    const [roles, setRoles] = useState([]);
    const [alliance, setAlliance] = useState([]);
    const [selectedAlliance, setSelectedAlliance] = useState();
    const [selectedRole, setSelectedRole] = useState();
    const { register, handleSubmit, reset, formState: { isSubmitting, isDirty, errors } } = useForm();
    const device = useDevice();
    const isMobile = device !== 'desktop';
    const showAlert = useAlert();

    useEffect(() => {

        fetch("/api/system/roles", {
            method: "GET"
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    setSelectedRole(json.data[0].id)
                    const newRolesList = json.data.map((item) => ({
                        ...item,
                        text: item.encodedNm,
                        value: item.id
                    }));
                    setRoles(newRolesList)
                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });

        fetch("/api/system/alliances", {
            method: "GET"
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    const newAlliance = json.data.map((item) => ({
                        ...item,
                        text: item.allianceName,
                        value: item.id
                    }));
                    setAlliance(newAlliance)
                    setSelectedAlliance(json.data[0].id)

                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });

    }, [])

    const handleCellNoChange = (e) => {
        const value = e.target.value;
        // 숫자와 대시만 허용
        const filteredValue = value.replace(/[^0-9-]/g, '');
        if (value !== filteredValue) {
            e.target.value = filteredValue;
        }
    };

    const autoHyphen = (target) => {
        // 전화번호 하이픈 자동 추가
        target.value = target.value
            .replace(/[^0-9]/g, "")
            .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
            .replace(/(\-{1,2})$/g, "");
    };

    const onSubmitHandler = (formData) => {
        if (formData.userId.trim() === '') {
            showAlert({title: "주의", text: "아이디를 입력해주세요.", type: "warning" });
            return;
        } else if (formData.password.trim() === '') {
            showAlert({title: "주의", text: "비밀번호를 입력해주세요.", type: "warning" });
            return;
        } else if (formData.userNm.trim() === '') {
            showAlert({title: "주의", text: "사용자명을 입력해주세요.", type: "warning" });
            return;
        } else if (formData.cellNo.trim() === '') {
            showAlert({title: "주의", text: "전화번호를 입력해주세요.", type: "warning" });
            return;
        } else if (formData.email.trim() === '') {
            showAlert({title: "주의", text: "이메일을 입력해주세요.", type: "warning" });
            return;
        }

        fetch("/api/system/users", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ...formData, allianceId: selectedAlliance, roleId: selectedRole }),
        })
            .then((res) => res.json())
            .then((json) => {
                if (json.code === responseMsg.SUCCESS.code) {
                    showAlert({title: "알림", text: "등록완료"});
                    rendering();
                    
                } else if (json.code === responseMsg.USER_DUPL_ID.code) {
                    showAlert({title: "경고", text: responseMsg.USER_DUPL_ID.message, type: "warning"});

                } else if (json.code === responseMsg.USER_DUPL_EMAIL.code) {
                    showAlert({title: "경고", text: responseMsg.USER_DUPL_EMAIL.message, type: "warning"});

                } else if (json.code === responseMsg.USER_DUPL_CELL_NO.code) {
                    showAlert({title: "경고", text: responseMsg.USER_DUPL_CELL_NO.message, type: "warning"});

                } else if (json.code === responseMsg.FAIL.code) {
                    showAlert({title: "경고", text: "통신이 지연되고 있습니다.", type: "warning"});
                }
            })
            .catch((error) => {
            });
    }

    return (
        <div>
            <form className="input_wrap" >
                <Grid paddingX={0}>
                    <div style={{ gridColumn: isMobile ? "span 2" : "span 1" }}>
                        <LabelInput id="userId" label={'아이디'} placeholder="아이디를 입력해 주세요" maxLength={20} required autoFocus {...register("userId")}/>
                    </div>
                    <div style={{ gridColumn: isMobile ? "span 2" : "span 1" }}>
                        <LabelInput type="password" id="userPw" label={'비밀번호'} placeholder="비밀번호를 입력해 주세요" maxLength={200} required {...register("password")}/>
                    </div>
                    <div style={{ gridColumn: isMobile ? "span 2" : "span 1" }}>
                        <LabelInput id="userName" label={'사용자명'} maxLength={200} placeholder="사용자명을 입력해 주세요" required {...register("userNm")}/>
                    </div>
                    <div style={{ gridColumn: isMobile ? "span 2" : "span 1" }}>
                        <LabelInput id="userDept" label={'부서'} maxLength={50} placeholder="부서를 입력해 주세요" {...register("department")}/>
                    </div>
                    <div style={{ gridColumn: isMobile ? "span 2" : "span 1" }}>
                        <LabelInput id="cellNo" label={'전화번호'} maxLength={13} placeholder="전화번호를 입력해 주세요" {...register("cellNo",{
                                onChange: ({ target }) => autoHyphen(target),
                            })}  required/>
                    </div>
                    <div style={{ gridColumn: isMobile ? "span 2" : "span 1" }}>
                        <LabelInput id="email" label={'이메일'} maxLength={50} placeholder="이메일을 입력해 주세요" {...register("email")} required />
                    </div>
                    <div style={{ gridColumn: isMobile ? "span 2" : "span 1" }}>
                        <CommonSelect label="권한" value={selectedRole} isModal data={roles} onChange={setSelectedRole} />
                    </div>
                    <div style={{ gridColumn: isMobile ? "span 2" : "span 1" }}>
                        <CommonSelect label="소속" value={selectedAlliance} isModal data={alliance} onChange={setSelectedAlliance} />
                    </div>
                    <div style={{ gridColumn: "span 2" }}>
                        <LabelInput id="userRemark" label={'비고'} maxLength={255} style={{gridColumn: "span 2"}} {...register("comment")} />
                    </div>
                </Grid>
            </form>

            <Spacer direction="vertical" size={15} />

            <Flex flexDirection={isMobile ? "column" : "row"} fullWidth justifyContent="end" gap={10}>
                <ModalButton type='insert' onClick={handleSubmit(onSubmitHandler)} />
                <ModalButton type='cancel' onClick={rendering} />
            </Flex>
        </div>
    );
}

export default UserAddModal;